import GatedSignInInfoModule from './GatedSignInInfoModule';

export default GatedSignInInfoModule;
